import $ from 'jquery'

class BlockProgramFinder extends window.HTMLDivElement {
  constructor () {
    super()
    this.$ = $(this)
    this.resolveElements()
  }

  resolveElements () {
  }

  connectedCallback () {
  }
}

window.customElements.define('flynt-block-program-finder', BlockProgramFinder, {extends: 'div'})



// WEBPACK FOOTER //
// ./Components/BlockProgramFinder/script.js